import { Box, GridItem } from '@flos/react-ui';
import { useRecoilValue } from 'recoil';
import { missingInformationAtom } from '../../../../recoil/atoms/missingInformationAtom';
import CaravanMissingInformationForm from '../CaravanMissingInformationForm';
import { allCoverablesAtom } from '../../../../recoil/atoms/allCoverablesAtom';

const CaravanMissingInformation = (): React.JSX.Element => {
    const allCoverables = useRecoilValue(allCoverablesAtom);
    const missingInformation = useRecoilValue(missingInformationAtom);
    const { caravan } = missingInformation;

    if (!caravan?.length) return <></>;

    return (
        <GridItem span={12}>
            <Box>
                {caravan
                    .filter((missingInformation) => !!missingInformation.fixedId)
                    .map((missingInformation) => {
                        const currentCoverableList = allCoverables.caravans;
                        if (!currentCoverableList) return <></>;
                        const currentCoverableIndex =
                            currentCoverableList?.findIndex(
                                (coverable) => coverable.fixedId === missingInformation.fixedId
                            ) ?? -1;
                        return (
                            <div key={missingInformation.fixedId}>
                                <CaravanMissingInformationForm
                                    caravanMissingDTO={missingInformation}
                                    currentCoverable={currentCoverableList[currentCoverableIndex]}
                                />
                            </div>
                        );
                    })}
            </Box>
        </GridItem>
    );
};

export default CaravanMissingInformation;
